import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/campaigns') {
      return location.pathname === '/campaigns' || location.pathname.startsWith('/campaigns/');
    }
    return location.pathname === path;
  };

  return (
    <div className="admin-layout">
      <nav className="admin-sidebar">
        <div className="sidebar-title">
          Tastuk Admin
        </div>
        <Link 
          to="/campaigns" 
          className={`nav-link ${isActive('/campaigns') ? 'active' : ''}`}
        >
          Campaigns
        </Link>
        <Link 
          to="/orders" 
          className={`nav-link ${isActive('/orders') ? 'active' : ''}`}
        >
          Order Management
        </Link>
      </nav>
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
}